const fitProcessor=(element)=>
{
let assembledElement = ""

if (element["Tests_positive"] !== "")
    {
    assembledElement += ` ${element["Tests_positive"]}`
    }

assembledElement += " positive FIT tests "

if (element["Tests_done"] !== "")
    {
    assembledElement += ` out of ${element["Tests_done"] } carried out`
    }

if (element["Highest_value_(if known)_ug/g"])
    {
    assembledElement += `with the highest value being ${element["Highest_value_(if known)_ug/g"]} ug/g`
    }

if (element["Date_of_most_recent_test"] !== "")
    {
    let testDate = new Date (element["Date_of_most_recent_test"])
    let testDateString = testDate.toLocaleDateString()
    assembledElement += `, the most recent test being carried out on ${testDateString}`
    }

if (element["Lab_where_test_performed:"] !== "")
    {
    assembledElement += `.  These were analysed at ${element["Lab_where_test_performed:"]} laboratory`
    }

if (element["Comments"] !== "")
    {
    assembledElement += `. Comments: ${element["Comments"]}`
    }

return (assembledElement)
}

export default fitProcessor